var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"t-banner-native",class:{_vertical: _vm.isVertical},attrs:{"to":_vm.banner.link}},[_c('img',{attrs:{"src":_vm.banner.img,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/lk/banner-native/banner-native.vue?vue&type=template&id=9fff797a&
// module id = 1059
// module chunks = 0